import React, { PropTypes } from 'react';
import { propTypes } from 'redux-form';
import { TaggingField } from 'common/components/form_fields';

const SpecializationField = ({
  input, specializationValue, specializationOptions, meta
}) => {
  if (!specializationValue) {
    return null;
  }

  return (<TaggingField
    input={input}
    options={specializationOptions}
    value={specializationValue}
    meta={meta}
  />);
};

SpecializationField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  specializationValue: PropTypes.string,
  specializationOptions: PropTypes.array,
};

export default SpecializationField;



// WEBPACK FOOTER //
// ./profile/components/specialization_field.jsx